import React from 'react'; // Ensure this is at the top
import dhlLogo from "../../../logo_dhl.gif";

const importAll = (r) => {
  let images = {};
  r.keys().forEach((item) => {
    const imageName = item.replace('./', '').toLowerCase();
    images[imageName] = r(item);
  });
  return images;
};

const logos = importAll(require.context('../../../assets', false, /\.(png|jpe?g|gif|bmp)$/));

const HeaderContent = ({toDisplayClientLogo, client, currentPage, locale, countryCode,}) => {
  locale = locale ? locale : "en";
  
  return (
    <header className="header">
    {/* <div className={currentPage === 'resultsPage' ? 'column-results' : 'column-left'}></div> */}
      <div className="column-middle" style={{ display: 'flex', alignItems: 'center' }}>
        <a
          href={`https://www.dhl.com/${countryCode.toLowerCase()}-${locale}/home.html?locale=true`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="logo" src={dhlLogo} alt="DHL Logo" />
        </a>
        {toDisplayClientLogo && client && client.logo && logos[client.logo.toLowerCase()] && (
          <a 
            href={client.custRedirectUrl ? client.custRedirectUrl : undefined} 
            target={client.custRedirectUrl ? "_blank" : undefined} 
            rel={client.custRedirectUrl ? "noopener noreferrer" : undefined}
            style={{ cursor: client.custRedirectUrl ? 'pointer' : 'default' }}
          >
            <img
              className={`client-logo ${client.isBackgroundRequiredForLogo && client.isBackgroundRequiredForLogo.toLowerCase() == 'y' ? 'client-logo-background' : ''} 
              ${client.isShadowRequiredForLogo && client.isShadowRequiredForLogo.toLowerCase() == 'y' ? 'client-logo-shadow' : ''}`}
              src={logos[client.logo.toLowerCase()]}
              alt={`${client.customerName} Logo`}
              style={{ marginLeft: '10px'}} // Add some space between logos
            />
          </a>
        )}
      </div>
      {/* <div className={currentPage === 'resultsPage' ? 'column-results' : 'column-right'}></div> */}
    </header>
  );
};

export default HeaderContent;